import { useMutation } from '@tanstack/react-query';

import { standbyWaitlistJoinMutation } from '@/api/standby/standbyWaitlistJoinMutation';

import type { UseStandbyWaitlistJoinMutationOptions } from './types';

// Options go THROUGH the factory so a caller cannot re-enable retry.
export const useStandbyWaitlistJoinMutation = (
  options?: UseStandbyWaitlistJoinMutationOptions,
) => useMutation(standbyWaitlistJoinMutation(options));
